/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Ranked_BadgeInputs */



/**
* | output |
* | --- |
* | "Ranked" |
*
* @param {Tournament_Ranked_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_ranked_badge = /** @type {((inputs?: Tournament_Ranked_BadgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Ranked_BadgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Classificado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Classificato")
	return /** @type {LocalizedString} */ ("Ranked")
});